import { render, staticRenderFns } from "./ToutiaoDefault.vue?vue&type=template&id=7bd7b1f9"
import script from "./ToutiaoDefault.vue?vue&type=script&lang=js"
export * from "./ToutiaoDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports